import React, { useEffect } from 'react'
import VariationCard from './VariationCard'
import { useInventoryStore } from '../../../state/useInventoryStore'
import PageLoader from '../../common/PageLoader'


const VariationList = ( {data, closeForm}: any ) => {

  const handleCloseForm = () => {
    closeForm()
  }

console.log(data)
  return (
    <div className='flex flex-col items-center'>

      {!data.length && !data ? 
    <>
    <p>No data Avaliable</p> 
    </>
    : data?.map(( item:any, index:any ) => {
         return (
         <div className='mb-[9px]'>
          <VariationCard key={index} item={item}/>
        </div>
         )
      })
    }

      <div>
        <button style={{fontWeight: 600}} onClick={handleCloseForm} className='w-[215px] border border-[#044E97] text-[#044E97] text-[16px] py-[16px]'>Create a new Variation</button>
      </div>
    </div>
  )
}

export default VariationList